var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, observable } from 'mobx';
import { getTagGroups, getTagTypeOptions } from '@gtintel/platform-api';
import { TAG_COLORS } from '@gtintel/platform-constants';
import { renderTitle } from './utils/tagType';
let TagGroupStore = (_class = class TagGroupStore {
  constructor(rootStore) {
    this.rootStore = void 0;
    _initializerDefineProperty(this, "tagGroups", _descriptor, this);
    _initializerDefineProperty(this, "tagTypeOptions", _descriptor2, this);
    this.rootStore = rootStore;
  }
  async fetchTagGroups(mode) {
    this.tagGroups = await getTagGroups(mode);
  }
  async fetchTagTypeOptionsRecursively(paginationParams) {
    const {
      next,
      results
    } = await getTagTypeOptions(paginationParams);
    const formattedOptions = results.map(option => ({
      key: option.id,
      value: option.name,
      label: renderTitle(option.name, TAG_COLORS[Number(option.code)])
    }));
    if (!paginationParams) {
      this.tagTypeOptions = formattedOptions;
    } else {
      this.tagTypeOptions = [...this.tagTypeOptions, ...formattedOptions];
    }
    if (next) {
      const nextPageParams = new URLSearchParams(next.split('?')[1]);
      if (nextPageParams?.get('offset')) {
        this.fetchTagTypeOptionsRecursively(nextPageParams.toString());
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "tagGroups", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tagTypeOptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "fetchTagGroups", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchTagGroups"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchTagTypeOptionsRecursively", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchTagTypeOptionsRecursively"), _class.prototype), _class);
export default TagGroupStore;